export enum MedicationStatusMessage {
  UpToDate = 'Up to date',
  Expiring = 'Expiring',
  Expired = 'Expired',
  Inactive = 'Inactive'
}

export enum UserAccessLevels {
  Owner = 'owner',
  Admin = 'admin',
  TeamMember = 'teamMember'
}